export default __webpack_public_path__ + "static/assets/739aaba44ece850bef76ba5a9ce502c4.png";